(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hulle-snap-helper"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-snaptag]'); if (!root) return;
  var urlIn = root.querySelector('[data-st-url]');
  var stage = root.querySelector('[data-st-stage]');
  var img = root.querySelector('[data-st-img]');
  var list = root.querySelector('[data-st-list]');
  var jsonOut = root.querySelector('[data-st-json]');
  var msg = root.querySelector('[data-st-msg]');
  var markers = []; // { x, y, handle, title, variant, variantLabel }

  // ★ ローカル画像は blob: URL になる。URL欄に入れても他の人が開けないので入れない
  function setImage(src, opts) {
    if (!src) return;
    if (!(opts && opts.local)) urlIn.value = src;
    img.src = src; img.style.display = 'block';
  }

  urlIn.addEventListener('input', function () { if (urlIn.value) { img.src = urlIn.value; img.style.display = 'block'; } });

  // ── 下書き（非公開）の記事の画像を読み込む ───────────────────────
  //   storefront の Liquid は公開済みの記事しか返さないので、下書きは一覧に出せない。
  //   画像さえ入れば印は置けるので、ファイル選択 / ドラッグ&ドロップ / 貼り付けを用意する。
  (function initLocalImage() {
    var box = root.querySelector('[data-st-draftbox]');
    var file = root.querySelector('[data-st-file]');
    if (!box || !file) return;

    function useFile(f) {
      if (!f || !/^image\//.test(f.type)) { note('画像ファイルを選んでください'); return; }
      setImage(URL.createObjectURL(f), { local: true });
      note('読み込みました: ' + f.name);
    }
    function note(t) { msg.textContent = t; setTimeout(function () { msg.textContent = ''; }, 2500); }

    file.addEventListener('change', function () { useFile(file.files && file.files[0]); });

    ['dragenter', 'dragover'].forEach(function (ev) {
      box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.remove('is-over'); });
    });
    box.addEventListener('drop', function (e) {
      var dt = e.dataTransfer; if (!dt) return;
      if (dt.files && dt.files[0]) { useFile(dt.files[0]); return; }
      var url = dt.getData('text/uri-list') || dt.getData('text/plain');
      if (url) setImage(url.trim());
    });

    // 画像をコピーして Ctrl+V（入力欄にフォーカスがあるときは邪魔しない）
    document.addEventListener('paste', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) return;
      var items = (e.clipboardData && e.clipboardData.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].type && items[i].type.indexOf('image/') === 0) {
          useFile(items[i].getAsFile()); e.preventDefault(); return;
        }
      }
    });
  })();

  // ── 画像ピッカー：SNAP記事にアップ済みの画像から選ぶ ──
  (function initPicker() {
    var sel = root.querySelector('[data-st-article]');
    var thumbs = root.querySelector('[data-st-thumbs]');
    if (!sel || !thumbs) return;
    var sources = [];
    try { sources = JSON.parse(root.querySelector('[data-st-sources]').textContent || '[]'); } catch (e) {}
    if (!sources.length) { sel.parentNode.style.display = 'none'; return; }
    sources.forEach(function (a, i) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = a.title + '（' + a.images.length + '枚）';
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      thumbs.innerHTML = '';
      var a = sources[sel.value];
      if (!a) { thumbs.hidden = true; return; }
      a.images.forEach(function (src) {
        var b = document.createElement('button'); b.type = 'button';
        b.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
        b.addEventListener('click', function () {
          var prev = thumbs.querySelector('.is-active'); if (prev) prev.classList.remove('is-active');
          b.classList.add('is-active');
          setImage(src);
        });
        thumbs.appendChild(b);
      });
      thumbs.hidden = false;
      if (a.images.length === 1) thumbs.querySelector('button').click();
    });
  })();

  stage.addEventListener('click', function (e) {
    if (e.target !== img) return;
    var r = img.getBoundingClientRect();
    var x = Math.round(((e.clientX - r.left) / r.width) * 1000) / 10;
    var y = Math.round(((e.clientY - r.top) / r.height) * 1000) / 10;
    markers.push({ x: x, y: y, handle: '', title: '' });
    render();
  });

  function render() {
    // dots
    var olds = stage.querySelectorAll('.st-dot'); for (var i = 0; i < olds.length; i++) olds[i].remove();
    markers.forEach(function (m, idx) {
      var d = document.createElement('div'); d.className = 'st-dot'; d.textContent = idx + 1;
      d.style.left = m.x + '%'; d.style.top = m.y + '%';
      enableDrag(d, idx);
      stage.appendChild(d);
    });
    // list
    list.innerHTML = '';
    markers.forEach(function (m, idx) {
      var li = document.createElement('li'); li.className = 'st-item';
      li.innerHTML =
        '<button class="st-del" title="削除">×</button>' +
        '<span class="st-item__head">#' + (idx + 1) + '　x:' + m.x + ' y:' + m.y + '</span>' +
        (m.handle ? '<span class="st-chosen">✓ ' + (m.title || m.handle) + '（' + m.handle + '）</span>' : '') +
        '<input type="text" placeholder="商品名で検索…" value="">' +
        '<ul class="st-results"></ul>' +
        '<div class="st-color" data-st-color hidden></div>';
      li.querySelector('.st-del').addEventListener('click', function () { markers.splice(idx, 1); render(); });
      if (m.handle) loadColors(li.querySelector('[data-st-color]'), idx);
      var inp = li.querySelector('input'); var res = li.querySelector('.st-results');
      inp.addEventListener('input', debounce(function () { search(inp.value, res, idx); }, 200));
      inp.addEventListener('focus', function () { if (inp.value) search(inp.value, res, idx); });
      inp.addEventListener('keydown', function (e) { onKeyNav(e, res); });
      list.appendChild(li);
    });
    sync();
  }

  function enableDrag(dot, idx) {
    dot.addEventListener('mousedown', function (ev) {
      ev.preventDefault();
      function move(e2) {
        var r = img.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, ((e2.clientX - r.left) / r.width) * 100));
        var y = Math.min(100, Math.max(0, ((e2.clientY - r.top) / r.height) * 100));
        markers[idx].x = Math.round(x * 10) / 10; markers[idx].y = Math.round(y * 10) / 10;
        dot.style.left = markers[idx].x + '%'; dot.style.top = markers[idx].y + '%';
      }
      function up() { document.removeEventListener('mousemove', move); document.removeEventListener('mouseup', up); render(); }
      document.addEventListener('mousemove', move); document.addEventListener('mouseup', up);
    });
  }

  // 全商品インデックス（Liquidで埋め込み済み）。これを使い真の部分一致で絞り込む。
  var PRODUCTS = [];
  try { PRODUCTS = JSON.parse(root.querySelector('[data-st-products]').textContent || '[]'); } catch (e) {}

  function norm(s) { return (s || '').toString().toLowerCase().replace(/\s+/g, ''); }

  function renderResults(items, res, idx) {
    res.innerHTML = '';
    items.forEach(function (p) {
      var li = document.createElement('li');
      li.innerHTML = (p.i ? '<img src="' + p.i + '">' : '') +
        '<span class="st-r-meta"><span>' + p.t + '</span>' +
        (p.v ? '<span class="st-r-vendor">' + p.v + '</span>' : '') + '</span>';
      li.addEventListener('click', function () { choose(idx, p.h, p.t, res); });
      res.appendChild(li);
    });
    res.classList.toggle('is-open', items.length > 0);
  }

  function search(q, res, idx) {
    q = (q || '').trim();
    if (!q) { res.classList.remove('is-open'); res.innerHTML = ''; return; }
    if (PRODUCTS.length) {
      // 商品名・ベンダーを対象に部分一致（スペース無視・大文字小文字無視）
      var nq = norm(q);
      var hits = PRODUCTS.filter(function (p) { return norm(p.t).indexOf(nq) > -1 || norm(p.v).indexOf(nq) > -1; }).slice(0, 12);
      renderResults(hits, res, idx);
      return;
    }
    // フォールバック: 商品数が250超でインデックス未取得の場合は suggest.json
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(items.map(function (p) {
          return { t: p.title, h: p.url.split('/products/')[1].split('?')[0], v: p.vendor || '', i: p.image || '' };
        }), res, idx);
      }).catch(function () {});
  }

  function choose(idx, handle, title, res) {
    markers[idx].handle = decodeURIComponent(handle); markers[idx].title = title;
    markers[idx].variant = null; markers[idx].variantLabel = '';
    res.classList.remove('is-open'); render();
  }

  // ── 色（バリエーション）────────────────────────────────────────
  //   ★ 全商品の色を先読みすると重いので、商品を選んだときだけ取りに行く。
  //   ★ 色を入れると、写真に写っている色の画像・リンク・価格でカードが出る。
  //      入れなければ従来どおり代表色（テーマ側が variant を任意扱いにしている）。
  var COLOR_CACHE = {};
  function fetchVariants(handle) {
    if (COLOR_CACHE[handle]) return Promise.resolve(COLOR_CACHE[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var vs = (p && p.variants) || [];
        // 色ごとに1つへまとめる。サイズ違いは先頭を使う (色が合っていれば画像は同じ)
        var seen = {}, groups = [];
        vs.forEach(function (v) {
          var c = v.option1 || v.title || '';
          if (seen[c]) return;
          seen[c] = true;
          groups.push({ id: v.id, color: c, hasSizes: false });
        });
        groups.forEach(function (g) {
          g.hasSizes = vs.filter(function (v) { return (v.option1 || v.title || '') === g.color; }).length > 1;
        });
        COLOR_CACHE[handle] = groups;
        return groups;
      })
      .catch(function () { return []; });
  }

  function loadColors(box, idx) {
    var m = markers[idx];
    if (!box || !m || !m.handle) return;
    fetchVariants(m.handle).then(function (groups) {
      // 1色しかない商品は色を選ぶ意味が無い
      if (!groups || groups.length < 2) { box.hidden = true; return; }
      var sel = document.createElement('select');
      var o0 = document.createElement('option');
      o0.value = ''; o0.textContent = '— 代表色のまま —';
      sel.appendChild(o0);
      var withSizes = false;
      groups.forEach(function (g) {
        var o = document.createElement('option');
        o.value = String(g.id); o.textContent = g.color;
        if (String(g.id) === String(m.variant)) o.selected = true;
        if (g.hasSizes) withSizes = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        var g = groups.filter(function (x) { return String(x.id) === sel.value; })[0];
        markers[idx].variant = g ? g.id : null;
        markers[idx].variantLabel = g ? g.color : '';
        sync();
      });
      box.innerHTML = '<span>写真に写っている色</span>';
      box.appendChild(sel);
      if (withSizes) {
        var n = document.createElement('span');
        n.className = 'st-color__note';
        n.textContent = 'サイズがある商品は、その色の先頭のサイズが選ばれた状態で開きます';
        box.appendChild(n);
      }
      box.hidden = false;
    });
  }

  // 矢印キーで候補移動 / Enter で選択 / Esc で閉じる
  function onKeyNav(e, res) {
    if (!res.classList.contains('is-open')) return;
    var opts = res.querySelectorAll('li');
    if (!opts.length) return;
    var cur = res.querySelector('li.is-active');
    var i = -1; for (var k = 0; k < opts.length; k++) { if (opts[k] === cur) { i = k; break; } }
    if (e.key === 'ArrowDown') { e.preventDefault(); i = (i + 1) % opts.length; }
    else if (e.key === 'ArrowUp') { e.preventDefault(); i = (i - 1 + opts.length) % opts.length; }
    else if (e.key === 'Enter') { e.preventDefault(); (cur || opts[0]).click(); return; }
    else if (e.key === 'Escape') { res.classList.remove('is-open'); return; }
    else { return; }
    if (cur) cur.classList.remove('is-active');
    opts[i].classList.add('is-active');
    opts[i].scrollIntoView({ block: 'nearest' });
  }

  function sync() {
    var out = markers.filter(function (m) { return m.handle; }).map(function (m) {
      // variant は任意。入れなければテーマ側は代表色で出す
      return m.variant
        ? { product: m.handle, variant: m.variant, x: m.x, y: m.y }
        : { product: m.handle, x: m.x, y: m.y };
    });
    jsonOut.value = JSON.stringify(out, null, 2);
  }

  root.querySelector('[data-st-copy]').addEventListener('click', function () {
    jsonOut.select(); document.execCommand('copy');
    msg.textContent = 'コピーしました'; setTimeout(function () { msg.textContent = ''; }, 1500);
  });
  root.querySelector('[data-st-load]').addEventListener('click', function () {
    try {
      var arr = JSON.parse(jsonOut.value);
      markers = arr.map(function (m) {
        return { x: m.x, y: m.y, handle: m.product, title: m.product, variant: m.variant || null, variantLabel: '' };
      });
      render(); msg.textContent = '読み込みました';
    } catch (e) { msg.textContent = 'JSONの形式が不正です'; }
    setTimeout(function () { msg.textContent = ''; }, 2000);
  });

  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
})();

  } catch(e) { console.error(e); }
})();
})();
